import { LeafAgingSummaryAmountColumn } from "@digits-graphql/frontend/graphql-bearer"
import { type ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"

export const TIME_COLUMNS = ["Current", "1-30 Days", "31-60 Days", "61-90 Days", "Older"] as const

// Applied as the first line for the x-axis on smaller aging charts
export const CONDENSED_TIME_COLUMNS = ["Current", "1-30", "31-60", "61-90", "Older"] as const

// Applied as a second line to the x-axis on smaller aging charts
export const SECOND_LINE_COLUMNS = ["", "Days", "Days", "Days", ""] as const

export const INVOICE_DATE = "Invoice Date" as const
export const DUE_DATE = "Due Date" as const
export const INVOICE_NUMBER = "Invoice #" as const
export const AMOUNT = "Amount"
export const TOTAL_COLUMN = "Total" as const

export const AGING_COLUMNS = [INVOICE_DATE, DUE_DATE, INVOICE_NUMBER, ...TIME_COLUMNS, TOTAL_COLUMN]

export const AGING_COLUMN_OFFSET = 3

export const LEAF_AGING_AMOUNT_COLUMNS: LeafAgingSummaryAmountColumn[] = [
  LeafAgingSummaryAmountColumn.Current,
  LeafAgingSummaryAmountColumn.OneToThirty,
  LeafAgingSummaryAmountColumn.ThirtyOneToSixty,
  LeafAgingSummaryAmountColumn.SixtyOneToNinety,
  LeafAgingSummaryAmountColumn.Older,
]

export const columnsByComponentSize = (componentSize: ComponentSize) => {
  if (componentSize.isExtraLarge || componentSize.isLarge) {
    return AGING_COLUMNS
  }
  if (componentSize.isMedium || componentSize.isSmall) {
    return [DUE_DATE, AMOUNT]
  }
  return []
}
